import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import '../styles/GSTDashboard.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const GSTDashboard = () => {
  // Doughnut Chart Data for GST Liability Overview
  const doughnutData = {
    labels: ['Total GST Collected', 'Total GST Paid (ITC)', 'Pending Liability'],
    datasets: [{
      data: [47250, 28750, 18500],
      backgroundColor: ['#3b82f6', '#22c55e', '#f59e0b'],
      borderWidth: 0,
      cutout: '75%',
    }],
  };

  const donutOptions = {
    plugins: { legend: { display: false }, tooltip: { enabled: true } },
    maintainAspectRatio: false,
  };

  // Mock Data Tables
  const summaryData = [
    { type: "CGST + SGST (Intra-State)", taxable: "₹2,45,000.00", cgst: "₹12,250.00", sgst: "₹12,250.00", igst: "₹0.00", cess: "₹0.00", total: "₹24,500.00" },
    { type: "IGST (Inter-State)", taxable: "₹1,85,000.00", cgst: "₹0.00", sgst: "₹0.00", igst: "₹22,750.00", cess: "₹0.00", total: "₹22,750.00" },
    { type: "CESS", taxable: "₹25,000.00", cgst: "₹0.00", sgst: "₹0.00", igst: "₹0.00", cess: "₹2,500.00", total: "₹2,500.00" },
  ];

  const recentInvoices = [
    { no: "INV-2025-158", date: "20 May 2025", customer: "Greenland Stores", taxable: "₹12,500.00", tax: "₹2,250.00", total: "₹14,750.00", status: "Paid" },
    { no: "INV-2025-157", date: "20 May 2025", customer: "Kumar Traders", taxable: "₹8,750.00", tax: "₹1,575.00", total: "₹10,325.00", status: "Paid" },
    { no: "INV-2025-156", date: "19 May 2025", customer: "Sai Retailers", taxable: "₹15,650.00", tax: "₹2,817.00", total: "₹18,467.00", status: "Paid" },
    { no: "INV-2025-155", date: "19 May 2025", customer: "Shree Enterprises", taxable: "₹21,200.00", tax: "₹3,816.00", total: "₹25,016.00", status: "Unpaid" },
    { no: "INV-2025-154", date: "18 May 2025", customer: "Modern Mart", taxable: "₹6,980.00", tax: "₹1,256.40", total: "₹8,236.40", status: "Paid" }
  ];

  const topSupplies = [
    { hsn: "2701", desc: "Petroleum Products", taxable: "₹85,000.00", tax: "₹15,300.00" },
    { hsn: "3105", desc: "Fertilizers", taxable: "₹62,000.00", tax: "₹11,160.00" },
    { hsn: "3915", desc: "Plastic Products", taxable: "₹48,500.00", tax: "₹8,730.00" },
    { hsn: "2106", desc: "Food Preparations", taxable: "₹36,000.00", tax: "₹6,480.00" },
    { hsn: "Other", desc: "Other Items", taxable: "₹2,23,500.00", tax: "₹5,580.00" }
  ];

  return (
    <div className="gst-wrapper">
      
      {/* Top KPI Grid */}
      <div className="gst-kpi-grid">
        <div className="gst-card gst-kpi-card">
          <div className="gst-kpi-header">
            <div className="gst-icon-box gst-bg-purple-light"><i className="fa-solid fa-wallet gst-text-purple"></i></div>
            <span className="gst-kpi-title">Total GST Collected</span>
          </div>
          <h2 className="gst-kpi-value">₹47,250.00</h2>
          <div className="gst-kpi-meta">
            <span>This Period</span>
            <span className="gst-trend-green"><i className="fa-solid fa-arrow-up"></i> 18.6%</span>
          </div>
        </div>
        
        <div className="gst-card gst-kpi-card">
          <div className="gst-kpi-header">
            <div className="gst-icon-box gst-bg-green-light"><i className="fa-solid fa-file-invoice-dollar gst-text-green"></i></div>
            <span className="gst-kpi-title">Total GST Paid (Purchases)</span>
          </div>
          <h2 className="gst-kpi-value">₹28,750.00</h2>
          <div className="gst-kpi-meta">
            <span>This Period</span>
            <span className="gst-trend-green"><i className="fa-solid fa-arrow-up"></i> 12.4%</span>
          </div>
        </div>

        <div className="gst-card gst-kpi-card">
          <div className="gst-kpi-header">
            <div className="gst-icon-box gst-bg-orange-light"><i className="fa-solid fa-scale-balanced gst-text-orange"></i></div>
            <span className="gst-kpi-title">Net GST Liability</span>
          </div>
          <h2 className="gst-kpi-value">₹18,500.00</h2>
          <div className="gst-kpi-meta">
            <span>Payable</span>
            <span className="gst-text-red">Due on 20 Jun 2025</span>
          </div>
        </div>

        <div className="gst-card gst-kpi-card">
          <div className="gst-kpi-header">
            <div className="gst-icon-box gst-bg-blue-light"><i className="fa-solid fa-money-bill-transfer gst-text-blue"></i></div>
            <span className="gst-kpi-title">Input Tax Credit (ITC)</span>
          </div>
          <h2 className="gst-kpi-value">₹28,750.00</h2>
          <div className="gst-kpi-meta">
            <span>Available</span>
            <span className="gst-text-green gst-fw-600">Eligible</span>
          </div>
        </div>

        <div className="gst-card gst-kpi-card">
          <div className="gst-kpi-header">
            <div className="gst-icon-box gst-bg-teal-light"><i className="fa-solid fa-chart-line gst-text-teal"></i></div>
            <span className="gst-kpi-title">Total Invoices (Taxable)</span>
          </div>
          <h2 className="gst-kpi-value">158</h2>
          <div className="gst-kpi-meta">
            <span>This Period</span>
            <span className="gst-trend-green"><i className="fa-solid fa-arrow-up"></i> 8.2%</span>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="gst-tabs-container">
        <div className="gst-tab active">GST Overview</div>
        <div className="gst-tab">Tax Invoices</div>
        <div className="gst-tab">GST Returns</div>
        <div className="gst-tab">HSN/SAC Codes</div>
        <div className="gst-tab">Tax Summary</div>
        <div className="gst-tab">Payment History</div>
      </div>

      {/* Main Layout Grid */}
      <div className="gst-main-layout">
        
        {/* LEFT COLUMN */}
        <div className="gst-left-col">
          
          {/* GST Summary Table */}
          <div className="gst-card gst-p-24">
            <div className="gst-card-header">
              <h3>GST Summary <span className="gst-text-muted gst-fw-normal">(This Period)</span></h3>
              <div className="gst-dropdown">This Period <i className="fa-solid fa-chevron-down"></i></div>
            </div>
            <div className="gst-table-wrapper">
              <table className="gst-table gst-summary-table">
                <thead>
                  <tr>
                    <th>Tax Type</th>
                    <th className="gst-align-right">Total Taxable Value</th>
                    <th className="gst-align-right">CGST</th>
                    <th className="gst-align-right">SGST</th>
                    <th className="gst-align-right">IGST</th>
                    <th className="gst-align-right">CESS</th>
                    <th className="gst-align-right">Total Tax</th>
                  </tr>
                </thead>
                <tbody>
                  {summaryData.map((row, i) => (
                    <tr key={i}>
                      <td className="gst-fw-500">{row.type}</td>
                      <td className="gst-align-right">{row.taxable}</td>
                      <td className="gst-align-right">{row.cgst}</td>
                      <td className="gst-align-right">{row.sgst}</td>
                      <td className="gst-align-right">{row.igst}</td>
                      <td className="gst-align-right">{row.cess}</td>
                      <td className="gst-align-right gst-fw-600">{row.total}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td>Total</td>
                    <td className="gst-align-right">₹4,55,000.00</td>
                    <td className="gst-align-right">₹12,250.00</td>
                    <td className="gst-align-right">₹12,250.00</td>
                    <td className="gst-align-right">₹22,750.00</td>
                    <td className="gst-align-right">₹2,500.00</td>
                    <td className="gst-align-right">₹47,250.00</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* Split Row: Invoices & Liability */}
          <div className="gst-split-row">
            
            {/* Recent Tax Invoices */}
            <div className="gst-card gst-p-24">
              <div className="gst-card-header">
                <h3>Recent Tax Invoices</h3>
                <a href="#" className="gst-link">View All</a>
              </div>
              <div className="gst-table-wrapper">
                <table className="gst-table gst-invoices-table">
                  <thead>
                    <tr>
                      <th>Invoice No.</th>
                      <th>Date</th>
                      <th>Customer</th>
                      <th className="gst-align-right">Taxable Value</th>
                      <th className="gst-align-right">Tax Amount</th>
                      <th className="gst-align-right">Total Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentInvoices.map((inv, i) => (
                      <tr key={i}>
                        <td><a href="#" className="gst-link-inv">{inv.no}</a></td>
                        <td className="gst-text-muted">{inv.date}</td>
                        <td className="gst-fw-500">{inv.customer}</td>
                        <td className="gst-align-right">{inv.taxable}</td>
                        <td className="gst-align-right">{inv.tax}</td>
                        <td className="gst-align-right gst-fw-600">{inv.total}</td>
                        <td><span className={`gst-badge gst-badge-${inv.status.toLowerCase()}`}>{inv.status}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="gst-mt-16">
                <a href="#" className="gst-link gst-link-icon">View all tax invoices <i className="fa-solid fa-arrow-right"></i></a>
              </div>
            </div>

            {/* GST Liability Overview */}
            <div className="gst-card gst-p-24">
              <h3 className="gst-mb-20">GST Liability Overview</h3>
              <div className="gst-donut-layout">
                <div className="gst-donut-wrapper">
                  <Doughnut data={doughnutData} options={donutOptions} />
                  <div className="gst-donut-center">
                    <span className="gst-dc-label">Net Liability</span>
                    <strong className="gst-dc-value">₹18,500.00</strong>
                  </div>
                </div>
                <div className="gst-donut-legend">
                  <div className="gst-leg-item">
                    <span className="gst-dot gst-bg-blue"></span>
                    <div className="gst-leg-text"><strong>Total GST Collected</strong><span>₹47,250.00 (51.3%)</span></div>
                  </div>
                  <div className="gst-leg-item">
                    <span className="gst-dot gst-bg-green"></span>
                    <div className="gst-leg-text"><strong>Total GST Paid (ITC)</strong><span>₹28,750.00 (31.2%)</span></div>
                  </div>
                  <div className="gst-leg-item">
                    <span className="gst-dot gst-bg-orange"></span>
                    <div className="gst-leg-text"><strong>Pending Liability</strong><span>₹18,500.00 (17.5%)</span></div>
                  </div>
                </div>
              </div>

              <div className="gst-info-box">
                <div className="gst-info-content">
                  <i className="fa-solid fa-circle-info gst-text-blue"></i>
                  <div>
                    <div className="gst-info-text">Your next GSTR-3B is due on <strong>20 Jun 2025</strong></div>
                    <div className="gst-info-sub">Period: May 2025</div>
                  </div>
                </div>
                <button className="gst-btn-primary">File GSTR-3B</button>
              </div>
            </div>
            
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="gst-right-col">
          
          {/* GST Return Summary */}
          <div className="gst-card gst-p-24">
            <div className="gst-card-header">
              <h3>GST Return Summary</h3>
              <a href="#" className="gst-link">View All</a>
            </div>
            <div className="gst-returns-list">
              <div className="gst-return-item">
                <div className="gst-icon-sm gst-bg-blue-light"><i className="fa-solid fa-file-invoice gst-text-blue"></i></div>
                <div className="gst-ret-text"><strong>GSTR-1</strong><span>Sales Details</span></div>
                <div className="gst-ret-status"><span className="gst-badge gst-badge-filed">Filed</span></div>
                <div className="gst-ret-date">11 May 2025</div>
              </div>
              <div className="gst-return-item">
                <div className="gst-icon-sm gst-bg-blue-light"><i className="fa-solid fa-file-invoice gst-text-blue"></i></div>
                <div className="gst-ret-text"><strong>GSTR-3B</strong><span>Summary Return</span></div>
                <div className="gst-ret-status"><span className="gst-badge gst-badge-filed">Filed</span></div>
                <div className="gst-ret-date">20 May 2025</div>
              </div>
              <div className="gst-return-item">
                <div className="gst-icon-sm gst-bg-green-light"><i className="fa-solid fa-file-arrow-down gst-text-green"></i></div>
                <div className="gst-ret-text"><strong>GSTR-2B</strong><span>ITC Statement</span></div>
                <div className="gst-ret-status"><span className="gst-badge gst-badge-downloaded">Downloaded</span></div>
                <div className="gst-ret-date">20 May 2025</div>
              </div>
              <div className="gst-return-item">
                <div className="gst-icon-sm gst-bg-orange-light"><i className="fa-solid fa-file-contract gst-text-orange"></i></div>
                <div className="gst-ret-text"><strong>GSTR-9</strong><span>Annual Return</span></div>
                <div className="gst-ret-status"><span className="gst-badge gst-badge-pending">Pending</span></div>
                <div className="gst-ret-date">-</div>
              </div>
              <div className="gst-return-item">
                <div className="gst-icon-sm gst-bg-red-light"><i className="fa-solid fa-file-signature gst-text-red"></i></div>
                <div className="gst-ret-text"><strong>GSTR-9C</strong><span>Reconciliation</span></div>
                <div className="gst-ret-status"><span className="gst-badge gst-badge-pending">Pending</span></div>
                <div className="gst-ret-date">-</div>
              </div>
            </div>
          </div>

          {/* Top Taxable Supplies */}
          <div className="gst-card gst-p-24">
            <div className="gst-card-header">
              <h3>Top Taxable Supplies <span className="gst-text-muted gst-fw-normal">(By HSN/SAC)</span></h3>
              <div className="gst-dropdown gst-sm-drop">This Period <i className="fa-solid fa-chevron-down"></i></div>
            </div>
            
            {/* THIS WRAPPER WAS MISSING AND CAUSED THE ISSUE */}
            <div className="gst-table-wrapper">
              <table className="gst-table gst-supplies-table">
                <thead>
                  <tr>
                    <th>HSN/SAC</th>
                    <th>Description</th>
                    <th className="gst-align-right">Taxable Value</th>
                    <th className="gst-align-right">Tax Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {topSupplies.map((item, i) => (
                    <tr key={i}>
                      <td className="gst-text-muted">{item.hsn}</td>
                      <td className="gst-fw-500">{item.desc}</td>
                      <td className="gst-align-right">{item.taxable}</td>
                      <td className="gst-align-right gst-fw-600">{item.tax}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* END WRAPPER */}

            <div className="gst-mt-16">
              <a href="#" className="gst-link gst-link-icon">View all HSN/SAC report <i className="fa-solid fa-arrow-right"></i></a>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="gst-card gst-p-24">
            <h3 className="gst-mb-20">Quick Actions</h3>
            <div className="gst-actions-grid">
              <div className="gst-action-card">
                <div className="gst-icon-md gst-bg-purple-light"><i className="fa-solid fa-file-circle-plus gst-text-purple"></i></div>
                <div className="gst-ac-text">
                  <strong>Create Tax Invoice</strong>
                  <span>Create new GST invoice</span>
                </div>
              </div>
              <div className="gst-action-card">
                <div className="gst-icon-md gst-bg-blue-light"><i className="fa-solid fa-money-check-dollar gst-text-blue"></i></div>
                <div className="gst-ac-text">
                  <strong>Record GST Payment</strong>
                  <span>Make GST payment</span>
                </div>
              </div>
              <div className="gst-action-card">
                <div className="gst-icon-md gst-bg-green-light"><i className="fa-solid fa-cloud-arrow-down gst-text-green"></i></div>
                <div className="gst-ac-text">
                  <strong>Import GSTR-2B</strong>
                  <span>Import purchases from portal</span>
                </div>
              </div>
              <div className="gst-action-card">
                <div className="gst-icon-md gst-bg-gray-light"><i className="fa-solid fa-gear gst-text-gray"></i></div>
                <div className="gst-ac-text">
                  <strong>GST Settings</strong>
                  <span>Configure GST settings</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default GSTDashboard;